import { Outlet } from 'react-router-dom';

import Header from './Header';
import Sidebar from './Sidebar';

const Layout = () => {
  return (
    <div className='flex flex-row h-screen min-h-0 overflow-hidden'>
      <Sidebar />
      <div className='flex flex-1 flex-col min-w-0 overflow-hidden'>
        <Header />
        <main className='flex-1 min-h-0 overflow-y-auto bg-app-page'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
